// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Ufow","ranges":"BmiRanges_ranges__1KpmZ"};